import { Component, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DatatableComponent } from '../datatable.component';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
    selector: 'lf-datatable-search',
    styleUrls: ['./datatable-search.scss'],
    templateUrl: './datatable-search.component.html',
})
export class DatatableSearchComponent implements OnInit
{
    @Input()
    public table: DatatableComponent;

    @Input()
    public config: { filter: string } = {
        filter: '',
    };

    @Input()
    public addBorder: boolean = false;

    @Input()
    public debounceTime: number = 500;

    @Output()
    public configChange: EventEmitter<{ filter: string }> = new EventEmitter<{ filter: string }>();

    @ViewChild('searchField')
    public searchField: HTMLInputElement;

    private debouncer = new Subject();

    public ngOnInit() {
        const self = this;
        this.debouncer
                .pipe(debounceTime(this.debounceTime))
                .subscribe((e: any) => {
                    self.configChange.emit(self.config);
                    self.table.filterResults();
                });
    }

    @HostListener('input', ['$event.target.value'])
    public onFilterChange(event: any): void {
        if (this.config.filter !== event) {
            this.config.filter = event;
            this.debouncer.next(event);
        }
    }

    public clearSearch() {
        this.config.filter = '';
        this.configChange.emit(this.config);
        this.table.filterResults();
    }
}
